import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = {
  key: 0,
  class: "btn-pagination"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "btn-pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "btn-pagination btn-pagination-icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.first && _ctx.first(...args)))
    }, [
      _createElementVNode("span", null, [
        _createVNode(_component_font_awesome_icon, { icon: "fa-angles-left" })
      ])
    ]),
    _createElementVNode("div", {
      class: "btn-pagination btn-pagination-icon",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args)))
    }, [
      _createElementVNode("span", null, [
        _createVNode(_component_font_awesome_icon, { icon: "fa-angle-left" })
      ])
    ]),
    (_ctx.frontEllipsisVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[4] || (_cache[4] = [
          _createElementVNode("span", null, "...", -1)
        ])))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfLinks, (num) => {
      return (_openBlock(), _createElementBlock("div", {
        key: num,
        class: _normalizeClass(['btn-pagination', {'btn-pagination-active': _ctx.startNumber + num - 1 === _ctx.modelValue}]),
        onClick: () => _ctx.goToNum(_ctx.startNumber + num - 1)
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.startNumber + num - 1), 1)
      ], 10, _hoisted_3))
    }), 128)),
    (_ctx.backEllipsisVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[5] || (_cache[5] = [
          _createElementVNode("span", null, "...", -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "btn-pagination btn-pagination-icon",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
    }, [
      _createElementVNode("span", null, [
        _createVNode(_component_font_awesome_icon, { icon: "fa-angle-right" })
      ])
    ]),
    _createElementVNode("div", {
      class: "btn-pagination btn-pagination-icon",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.last && _ctx.last(...args)))
    }, [
      _createElementVNode("span", null, [
        _createVNode(_component_font_awesome_icon, { icon: "fa-angles-right" })
      ])
    ])
  ]))
}